import React, { useEffect } from 'react';
import { useModal } from '~shared/components/modal-overlay/ModalContext';
import { openOnboardingPageWithContext } from '~shared/components/favorite-sport-modal/utils';
import {
    onUserAuthenticationSucceeded,
    onPostRegistrationDepositClosed,
    onOpenFavouriteSportsModal,
} from '~spa/Utils/WrapperIntegration/Ucf';
import {
    isFirstLogin,
    didReceivePRDCMessage,
    setDidReceivePRDCMessage,
} from '~shared/utils/user';

/**
 * MessageBrokerSubscriptionHandler is intended to be a place where we can subscribe for message broker messages
 * and show modals based on the message.
 *
 * @returns {ReactElement} MessageBrokerSubscriptionHandler
 */
const MessageBrokerSubscriptionHandler = () => {
    const modalContext = useModal();
    const openOnboardingPage = () => openOnboardingPageWithContext(modalContext);

    const handleOnboardingModalOpen = () => {
        if (isFirstLogin() && didReceivePRDCMessage()) {
            openOnboardingPage();
        }
    };

    useEffect(() => {
        const subscriptions = [];
        /**
         * to show the onboarding modal we have to have recieved the didReceivePRDCMessage
         * from the wrapper and have successfully authenticated. This can happen in any order
         * so we call handleOnboardingModalOpen on receiving both of these messages.
         */
        subscriptions.push(
            onUserAuthenticationSucceeded(handleOnboardingModalOpen)
        );
        subscriptions.push(
            onPostRegistrationDepositClosed(() => {
                setDidReceivePRDCMessage(true);
                handleOnboardingModalOpen();
            })
        );
        subscriptions.push(
            onOpenFavouriteSportsModal(openOnboardingPage)
        );

        return () => subscriptions.forEach(subscription => subscription.unsubscribe());
    }, []);

    return <></>;
};

export default MessageBrokerSubscriptionHandler;
